import dayjs from "dayjs";

export const calculateAge = (date: string | undefined) => {
  if (date === undefined || date === null) return "";

  return dayjs().diff(dayjs(date), "year");
};
